import type { EditorSnapshot } from './types';

const MAX_HISTORY = 20;

export class HistoryManager {
  private undoStack: EditorSnapshot[] = [];
  private redoStack: EditorSnapshot[] = [];
  private onChange: () => void;

  constructor(onChange: () => void) {
    this.onChange = onChange;
  }

  push(snapshot: EditorSnapshot): void {
    this.undoStack.push(snapshot);
    if (this.undoStack.length > MAX_HISTORY) {
      this.undoStack.shift();
    }
    this.redoStack = [];
    this.onChange();
  }

  undo(): EditorSnapshot | null {
    if (this.undoStack.length < 2) return null;
    const current = this.undoStack.pop()!;
    this.redoStack.push(current);
    this.onChange();
    return this.undoStack[this.undoStack.length - 1];
  }

  redo(): EditorSnapshot | null {
    if (this.redoStack.length === 0) return null;
    const snapshot = this.redoStack.pop()!;
    this.undoStack.push(snapshot);
    this.onChange();
    return snapshot;
  }

  get canUndo(): boolean {
    return this.undoStack.length >= 2;
  }

  get canRedo(): boolean {
    return this.redoStack.length > 0;
  }

  clear(): void {
    this.undoStack = [];
    this.redoStack = [];
    this.onChange();
  }

  get current(): EditorSnapshot | null {
    return this.undoStack.length > 0 ? this.undoStack[this.undoStack.length - 1] : null;
  }
}
